import React, { memo, useCallback } from 'react'

import DatePicker from '../../../../Mantine/DatePicker'

import * as S from './styles'

const DatePickerFilter = ({ nome, localFilters, setLocalFilters }) => {
  const handleChange = useCallback(
    (campo, value) => {
      setLocalFilters((prev) => ({
        ...prev,
        [nome]: { ...prev[nome], [campo]: value }
      }))
    },
    [setLocalFilters, nome]
  )

  return (
    <S.DatePickerWrapper>
      <DatePicker
        prefixo="De:"
        value={localFilters?.[nome]?.DE}
        maxDate={localFilters?.[nome]?.ATE || new Date()}
        onChange={(date) => handleChange('DE', date)}
      />
      <DatePicker
        prefixo="Até:"
        minDate={localFilters?.[nome]?.DE}
        maxDate={new Date()}
        value={localFilters?.[nome]?.ATE}
        onChange={(date) => handleChange('ATE', date)}
      />
    </S.DatePickerWrapper>
  )
}

export default memo(DatePickerFilter)
